// import '../App.css';
import { secureStorage } from "../SecureStorage";
import '../css/auth.css';
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';



function Auth({ onLogin, type }) {
  const navigate = useNavigate();
  const [orgName, setOrgName] = useState('');
  const [handle, setHandle] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const isRegister = type === 'signup';
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [canResend, setCanResend] = useState(false);
  const [forgotMode, setForgotMode] = useState(false); // controls reset UI

  const [showPassword, setShowPassword] = useState(false); // show or hide password

  const [handleTouched, setHandleTouched] = useState(false); // Generate handle


  const isHandleValid = (h) => /^[a-z0-9-_]+$/.test(h);

  const isFormValid = () => {
    return (
      email.trim() &&
      (forgotMode
        ? true // only email is needed
        : password.trim() &&
          (isRegister ? orgName.trim() && handle.trim() && isHandleValid(handle.trim()) : true))
    );
  };

  const handleAuth = async () => {
    if (!isFormValid()) {
      setErrors([
        {
          msg: 'Please fill out all fields correctly. Handle can only contain lowercase letters, numbers, hyphens, and underscores.',
        },
      ]);
      return;
    }

     // REGISTRATION WARNING CHECKS
    if (isRegister && !isHandleValid(handle.trim())) {
      setErrors([
        { msg: "Handle is invalid. Use only lowercase letters, numbers, hyphens, and underscores." }
      ]);
      return;
    }

    setLoading(true);
    setErrors([]);
    setSuccessMessage('');
    setCanResend(false);

    try {
      if (forgotMode) {
        // --- Forgot password flow ---
        // await axios.post(`http://localhost:8000/forgot_password/?org_email=${email}`);
        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/forgot_password/?org_email=${email}`
        );
        setSuccessMessage('📨 Password reset link sent! Please check your inbox.');
        setForgotMode(false); // go back to login view
      } else {
        // --- Signup / Login flow ---
        const endpoint = isRegister ? '/org/register/' : '/org/login/';
        const payload = isRegister
          ? { name: orgName, email, password, handle: handle.trim().toLowerCase() }
          : { email, password };
    
        // const response = await axios.post(`http://localhost:8000${endpoint}`, payload);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
          payload
        );
        
    
        if (isRegister) {
          // ✅ Registration successful, but do NOT log in yet
          setSuccessMessage(
            '✅ Registration successful! Please check your email to verify your account before logging in.'
          );
          // allow resend after 1 min
          setTimeout(() => setCanResend(true), 60000);
        } else {
          // ✅ Login successful: store token securely
          const token = response.data.access_token;
    
          // Save token (use your secureStorage wrapper here instead of localStorage directly)
          secureStorage.setItem("auth_token", token);
    
          // Optionally decode token just to extract org_id (don’t trust it blindly!)
          let orgId = null;
          try {
            const decoded = JSON.parse(atob(token.split(".")[1])); // decode JWT payload
            orgId = decoded.org_id || null;
          } catch (e) {
            console.error("Failed to decode token", e);
          }
    
          // Fire your login callback
          onLogin(orgId);
    
          setSuccessMessage('Login successful!');
          navigate('/dashboard');
        }
    
        // Clear form fields
        setOrgName('');
        setHandle('');
        setEmail('');
        setPassword('');
      }
    } catch (err) {
      if (err.response?.status === 422 && Array.isArray(err.response.data.detail)) {
        const formattedErrors = err.response.data.detail.map((e) => ({ msg: e.msg }));
        setErrors(formattedErrors);
      } else if (err.response?.data?.detail) {
        setErrors([{ msg: err.response.data.detail }]);
      } else {
        setErrors([{ msg: 'Something went wrong. Please try again.' }]);
      }
    } finally {
      setLoading(false);
    }
    
  };

  const resendVerification = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/verify_email/?org_email=${email}`
      );
      
      // await axios.post(`http://localhost:8000/verify_email/?org_email=${email}`);
      setSuccessMessage('📨 Verification email resent! Please check your inbox.');
      setCanResend(false);
      setTimeout(() => setCanResend(true), 60000); // allow again after 1 min
    } catch {
      setErrors([{ msg: 'Failed to resend verification email.' }]);
    }
  };

  // const generateHandle = (name) => {
  //   return name
  //     .toLowerCase()
  //     .replace(/[^a-z0-9\s-]/g, "")   // remove special chars
  //     .replace(/\s+/g, "-")           // spaces → hyphens
  //     .slice(0, 20);                  // max length
  // };
  
  const generateHandle = (name) => {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, "")  // remove special characters
      .replace(/\s+/g, "")          // remove ALL spaces completely
      .slice(0, 20);                // limit length
  };
  
  

  return (
    <div className="auth-container">
      <h2 className="auth-title">
        {forgotMode
          ? 'Forgot Password'
          : isRegister
          ? 'Register Organization'
          : 'Login Organization'}
      </h2>

      {successMessage && <p className="success-message">{successMessage}</p>}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAuth();
        }}
      >
        {/* {isRegister && !forgotMode && (
          <>
            <input
              type="text"
              placeholder="Organization Name"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
              className="input-field"
              disabled={loading}
            />
            <input
              type="text"
              placeholder="Handle (unique, lowercase, no spaces)"
              value={handle}
              onChange={(e) => setHandle(e.target.value.toLowerCase())}
              className="input-field"
              disabled={loading}
            />
          </>
        )} */}

        {isRegister && !forgotMode && (
          <>
            <input
              type="text"
              placeholder="Organization Name"
              value={orgName}
              onChange={(e) => {
                const value = e.target.value;
                setOrgName(value);

                // Auto-generate handle ONLY if the user hasn’t typed in the handle manually
                if (!handleTouched) {
                  setHandle(generateHandle(value));
                }
              }}
              className="input-field"
              disabled={loading}
            />

            <input
              type="text"
              placeholder="Handle (unique, lowercase, no spaces)"
              value={handle}
              onChange={(e) => {
                setHandle(e.target.value.toLowerCase());
                setHandleTouched(true); // Mark that the user manually edited handle
              }}
              className="input-field"
              disabled={loading}
            />
          </>
        )}


        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-field"
          disabled={loading}
        />

        {/* {!forgotMode && (
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-field"
            disabled={loading}
          />
        )} */}

        {!forgotMode && (
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
              disabled={loading}
            />

            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "🙈" : "👁️"}
            </span>
          </div>
        )}


        <button
          type="submit"
          disabled={loading || !isFormValid()}
          className="primary-button"
        >
          {loading
            ? 'Loading...'
            : forgotMode
            ? 'Send Reset Link'
            : isRegister
            ? 'Register'
            : 'Login'}
        </button>
      </form>

      {/* Forgot password toggle (only show on login) */}
      {!isRegister && !forgotMode && (
        <p
          className="forgot-password-link"
          onClick={() => {
            setErrors([]);
            setSuccessMessage('');
            setForgotMode(true);
          }}
          style={{ cursor: 'pointer', marginTop: '10px', color: '#1a73e8' }}
        >
          Forgot your password?
        </p>
      )}

      {/* Back to login from forgot password */}
      {forgotMode && (
        <p
          className="back-to-login-link"
          onClick={() => setForgotMode(false)}
          style={{ cursor: 'pointer', marginTop: '10px', color: '#1a73e8' }}
        >
          Back to login
        </p>
      )}

      {/* Show resend option */}
      {isRegister &&
        successMessage.includes('verify your account') &&
        canResend && (
          <button className="secondary-button" onClick={resendVerification}>
            Resend Verification Email
          </button>
        )}

      {errors.length > 0 && (
        <div className="error-messages">
          {errors.map((err, idx) => (
            <p key={idx} className="error-text">
              {err.msg}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}

export default Auth;

